import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    maxWidth: '300px',
    '& > div:first-child': {
      padding: '1rem',
    },
    '& $list + $list': {
      marginTop: '1.5rem',
    },
  },
  list: {
    maxHeight: '250px',
    width: '300px',
    overflow: 'auto',
    paddingBottom: '1rem',
    '& > span': {
      padding: '0 1rem',
    },
  },
  listItem: {
    padding: '0rem 1rem',
  },
  label: {
    maxWidth: '75%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  icon: {
    height: '1.5rem',
    width: '1.5rem',
    filter: 'invert(40%) sepia(5%) saturate(1448%) hue-rotate(163deg) brightness(94%) contrast(85%)',
  },
}));
